import { csx } from '@vtex/admin-ui'

export const styles = {
  modalHeader: csx({
    paddingBottom: '0',
  }),
  modalContent: csx({
    marginTop: '$space-3',
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-6',
    paddingTop: '0',
  }),
  modalSubtitle: csx({
    margin: '$space-3 1.75rem 0 1.75rem',
  }),
  budgetWarninig: csx({
    marginTop: '$space-2',
    display: 'flex',
    justifyContent: 'center',
    background: '$orange10',
    padding: '0.625rem 0',
  }),
}
